import React, { useEffect, useState } from "react";
import {
  Buildings,
  Location,
  Messages2,
  People
} from "iconsax-react";
import { useNavigate } from "react-router-dom";

const Prevstatus = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  if (!user) {
    return <div>Loading...</div>;
  }

  const handleKycClick = () => {
    navigate("/kydetailsform", { state: { user } });
  };

  return (
    <>
      <div className="hader"></div>
      <div className="form-container">
        <div></div>
      </div>
      <div className="card_container">
        <div className="row">
          <div className="col">
            <div className="card_body_cmp">
              <div className="d-flex justify-content-center mb-3">
                <button className="btn btn-warning" onClick={handleKycClick}>
                  Complete KYC
                </button>
              </div>

              <div className="card_box">
                <p>
                  Status:{" "}
                  <span style={{ color: "red", fontWeight: "600" }}>
                    Pending
                  </span>
                </p>
              </div>

              <div className="card_box">
                <p>Company Name</p>
                <p className="icon_sax_organization">
                  <span>
                    <Buildings size="30" color="#007bff" variant="Bulk" />
                  </span>{" "}
                  {user.member_firm_name || "N/A"}
                </p>
              </div>

              <div className="card_box">
                <p>Company Type</p>
                <p className="icon_sax_organization">
                  <span>
                    <People size="30" color="#007bff" variant="Bulk" />
                  </span>{" "}
                  {user.member_business_type || "N/A"}
                </p>
              </div>

              <div className="card_box">
                <p>Email</p>
                <p className="icon_sax_organization">
                  <span>
                    <Messages2 size="30" color="#007bff" variant="Bulk" />
                  </span>{" "}
                  {user.member_email || "N/A"}
                </p>
              </div>

              <div className="card_box">
                <p>Address</p>
                <p className="icon_sax_organization">
                  <span>
                    <Location size="30" color="#007bff" variant="Bulk" />
                  </span>{" "}
                  {user.member_city}, {user.member_state} - {user.member_pin}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Prevstatus;
